.badge {
  display: inline-flex;
  align-items: center;
  gap: var(--space-1);
  height: var(--size-badge);
  padding: 0 var(--space-1-5);
  border: 1px solid transparent;
  border-radius: var(--radius-sm);
  font-size: var(--text-xs);
  font-weight: var(--weight-medium);
  line-height: 1;
  white-space: nowrap;
}

.icon {
  display: inline-flex;
}

.icon svg {
  width: var(--size-icon-sm);
  height: var(--size-icon-sm);
  flex-shrink: 0;
}

.neutral {
  border-color: var(--color-border);
  background: var(--color-surface-sunken);
  color: var(--color-fg-muted);
}

.accent {
  background: var(--color-accent-subtle);
  color: var(--color-accent-text);
}

.pass {
  background: var(--color-pass-subtle);
  color: var(--color-pass);
}

.fail {
  background: var(--color-fail-subtle);
  color: var(--color-fail);
}

.warn {
  background: var(--color-warn-subtle);
  color: var(--color-warn);
}

.skip {
  background: var(--color-skip-subtle);
  color: var(--color-skip);
}
